import { Component, OnInit, ChangeDetectionStrategy, Input, OnDestroy } from '@angular/core';
import { Params, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {
  AuthStore,
  BookingService,
  BookingStore,
  BookingSubscription,
  InstallationsStore,
  Platform,
} from '@store';
import moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SubscriptionPlan, SubscriptionStatus } from '../../../../projects/client';

@Component({
  selector: 'app-booking-extend-trial-details',
  templateUrl: './booking-extend-trial-details.component.html',
  styleUrls: ['./booking-extend-trial-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingExtendTrialDetailsComponent implements OnInit, OnDestroy {
  readonly subscriptionsStatusType = SubscriptionStatus;
  readonly subscriptionsPlanType = SubscriptionPlan;
  @Input() subscription: BookingSubscription;

  private ngUnsubscribe$: Subject<void> = new Subject<void>();
  public gatewayPlatformType: Platform;
  public readonly platform = Platform;

  get isExpired(): boolean {
    return this.subscription.status?.toLowerCase() === SubscriptionStatus.expired;
  }

  constructor(
    public bookingStore: BookingStore,
    public authStore: AuthStore,
    public bookingService: BookingService,
    private translation: TranslateService,
    private router: Router,
    private installationsStore: InstallationsStore
  ) {}

  ngOnInit(): void {
    if (this.subscription.installationId) {
      this.installationsStore
        .getPlatformTypeWithInstallationId(this.subscription.installationId)
        .pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe((platform) => {
          this.gatewayPlatformType = platform;
        });
    }
  }

  onProceedSubscription(deviceSerial: string): void {
    const queryParams: Params = {
      deviceSerial,
      gatewayPlatformType: this.gatewayPlatformType,
    };
    this.router.navigate(['/booking-extend-trial'], {
      queryParams,
    });
  }

  getLeftDays(date: Date): string {
    const expirationDate = moment(date);
    const currentDate = moment();
    const leftDays = expirationDate.diff(currentDate, 'days');

    return leftDays === 1
      ? `${leftDays} ${this.translation.instant('+BOOKING.OVERVIEW.SUBSCRIPTION.DAY')}`
      : `${leftDays} ${this.translation.instant('+BOOKING.OVERVIEW.SUBSCRIPTION.DAYS')}`;
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
